import { IMAGE_PATHS } from 'constants/imagePaths';
import React from 'react';
import { Image } from 'react-bootstrap';
import useTranslate from 'hooks/useTranslate';
import useAuthStore from 'store/auth';
import { S3_URL, USER_TYPES } from 'constants';
import { unitNumber } from 'utils';
import { useNavigate } from 'react-router-dom';
import './styles.scss';

const Profile: React.FC<any> = ({ onClose }) => {
	const { translate } = useTranslate();
	const userDetails: any = useAuthStore((state) => state.userInfo.user);
	const navigate = useNavigate();

	const goToConnectionList = () => {
		if (userDetails?.userType === USER_TYPES.COMPANY) {
			navigate('/company/followers-list?activeTab=followers&value=');
		} else {
			navigate(`/seeker/my-connections?activeTab=connected&value=`);
		}
		onClose();
	};

	const goToFollowingList = () => {
		navigate(`/${userDetails?.userType}/followings-list?activeTab=company&value=`);
		onClose();
	};

	const goToEmployeeList = () => {
		navigate(`/company/followers-list?activeTab=employees&value=`);
		onClose();
	};

	return (
		<>
			<div>
				<div className="w-100 user-profile-bg">
					<Image
						src={
							userDetails?.coverPicture
								? `${S3_URL}${userDetails.coverPicture}`
								: IMAGE_PATHS.UserBG
						}
						alt="bg"
						className="w-100 h-100 object-fit-cover"
						loading="lazy"
					/>
				</div>
				<div
					className="user-profile mx-auto"
					onClick={() => navigate(`/${userDetails?.userType}/profile`)}
				>
					<Image
						src={
							userDetails?.profilePicture
								? `${S3_URL}${userDetails.profilePicture}`
								: IMAGE_PATHS.UserDefault
						}
						alt="img"
						className="w-100 h-100 object-fit-cover"
						loading="lazy"
					/>
				</div>
			</div>
			<div
				className="user-info"
				onClick={() => {
					if (onClose) {
						onClose();
					}
					navigate(`/${userDetails?.userType}/profile`);
				}}
			>
				<h4 className="mb-1 fw-bold">
					{userDetails?.userType === USER_TYPES.COMPANY
						? userDetails?.companyName
						: `${userDetails?.firstName} ${userDetails?.lastName}`}
				</h4>

				<p className="mb-0">
					{userDetails?.userType === USER_TYPES.COMPANY
						? `${userDetails?.industryName} ${userDetails?.industryName?.length > 0 ? ',' : ''} ${userDetails?.address}`
						: userDetails?.designation}
				</p>
			</div>
			<div className="d-flex justify-content-center gap-2">
				<p style={{ cursor: 'pointer' }} className="mb-0" onClick={goToConnectionList}>
					<span>
						{unitNumber(
							userDetails?.userType === USER_TYPES.COMPANY
								? userDetails?.followers
								: userDetails?.connection,
							0,
						)}
					</span>{' '}
					{userDetails?.userType === USER_TYPES.COMPANY
						? translate('Common.followers')
						: translate('Common.connection')}
				</p>
				<p className="mb-0">•</p>
				<p style={{ cursor: 'pointer' }} className="mb-0" onClick={goToFollowingList}>
					<span>{unitNumber(userDetails?.followings, 0)}</span> {translate('Sidebar.followings')}
				</p>
			</div>
			{userDetails?.userType === USER_TYPES.COMPANY && (
				<div style={{ marginTop: '-10px' }}>
					<p style={{ cursor: 'pointer' }} className="mb-0" onClick={goToEmployeeList}>
						<span>{unitNumber(userDetails?.employees, 0)}</span> {translate('Common.employees')}
					</p>
				</div>
			)}
		</>
	);
};

export default Profile;
